import { SelectItem } from '@oncolens/oncolens-ui/lib/components/FormControls/Listbox';
import { CancerConfig, Config } from '../configs/cancerConfig';

export function getConfigValueFromId(id: string | undefined, config: Config[] | undefined) {
  return config && id ? config.find((x) => x.value === id)?.label : null;
}

export function mapConfig(config: Config[] | undefined) {
  return config ? (config.map((x) => ({ value: x.value, label: x.label })) as SelectItem[]) : [];
}

export function getCancerTypeFromId(
  cancerTypeId: string | undefined,
  config: CancerConfig[] | undefined
) {
  return config && cancerTypeId ? config.find((x) => x.value === cancerTypeId) : null;
}

export function getPathologyTextFromId(
  pathologyId: string | undefined,
  cancerType: CancerConfig | null | undefined
) {
  return cancerType ? cancerType.pathologies.find((x) => x.value === pathologyId)?.label : null;
}

export function getLocationTextFromId(
  locationId: string | undefined,
  cancerType: CancerConfig | null | undefined
) {
  return cancerType ? cancerType.locations.find((x) => x.value === locationId)?.label : null;
}

export function isLocationLateral(
  locationId: string | undefined,
  config: CancerConfig[] | undefined
) {
  const cancerType = config?.find((cancerType) =>
    cancerType.locations.some((location) => {
      return location.value.toLowerCase() === locationId?.toLowerCase();
    })
  );
  const location = cancerType?.locations.find(
    (x) => x.value.toLowerCase() === locationId?.toLowerCase()
  );
  return location != null && location?.laterality === true;
}

export function mapCancerConfig<T extends SelectItem>(config: CancerConfig[] | undefined) {
  return config
    ? config?.reduce<T[]>(
      (accumulator, currentValue) =>
        accumulator.concat(
          currentValue.locations.map<T>(
            (location) =>
              ({
                value: location.value,
                label: `${currentValue.label} - ${location.label}`
              } as T)
          )
        ),
      []
		  )
    : [];
}

export function getCancerTypeByLocation(locationId?: string | null, configs?: any) {
  const cancerConfigs = configs?.cancer ?? [];
  const match = cancerConfigs.find((cancerConfig: any) => {
    const locations = cancerConfig.locations ?? [];
    const matchingLocation = locations.find((location: any) => {
      return locationId === location.value;
    });
    return !!matchingLocation;
  });
  return match;
}

// Gets the 'sub collections' (arrays) that exist for a cancer type. Those are used to populate the different dropdowns that
// depend on what the location value is (disease type/pathology, areas of metastasis)
export function getSubCollectionsFromCancerType(
  config: CancerConfig[] | undefined,
  locationTypeId: string
) {
  const cancerType = config?.find((cancerType) =>
    cancerType.locations.some((location) => location.value === locationTypeId)
  );

  return {
    pathologies: mapConfig(cancerType?.pathologies)
  };
}

export function getCancerConfigPathologyOtherUuids(config: CancerConfig[] | undefined) {
  return config
    ? config?.reduce<string[]>(
      (accumulator, currentValue) =>
        accumulator.concat(
          currentValue.pathologies
            .filter(
              (pathology) => pathology.label === 'Other - please specify as a comment below'
            )
            .map((pathology) => pathology.value)
        ),
      []
		  )
    : [];
}
